<app-card
  title="Order Complete!"
  data-qa-id="Order Complete Instructions"
  headerClasses="p-6 is-size-3 is-size-4-mobile has-text-weight-bold card-header-title has-text-white"
  [contentClasses]="'card-body-background p-6 ' + cardContentClass"
>
  <p class="mb-4"><strong>Your order has been placed!</strong></p>
  @if (!treatmentType) {
    <p class="mb-4">
      We’ve received your order, and you’ll receive an email confirmation once your order has shipped with tracking
      details.
    </p>
    <p class="mb-4">
      Thank you for choosing {{ siteName }}. We're committed to providing you with fast, affordable, and convenient
      care.
    </p>
  } @else {
    <p class="mb-4">
      Your order has been successfully placed. Please take a moment to check your email at
      {{ orderCompleteDetails.email }}, where you will find a link to complete a medical questionnaire.
    </p>
    <p class="mb-4">
      <span class="has-background-warning"
        >Or, you can
        <a
          data-qa-id="Consultation Request Btn"
          [href]="getConsultationPageUrl()"
          class="is-clickable has-text-dark has-text-weight-ultrabold"
        >
          CLICK HERE
        </a>
        to take it now.
      </span>
    </p>
    <p class="mb-4">
      This questionnaire is essential as it will enable our team of experienced medical professionals to thoroughly
      evaluate your symptoms and prescribe the most suitable medication for your treatment.
    </p>
    <p class="mb-4">
      Thank you for trusting us with your healthcare needs. We take pride in providing you with safe, affordable, and
      convenient treatment. We look forward to helping you feel better soon.
    </p>
  }
  <p class="mb-4">
    Best regards,
    <br />
    The {{ siteName }} Team
  </p>
</app-card>
